import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import { VueMasonryPlugin } from 'vue-masonry'


import i18n from './i18n'

// Dev-only: hide noisy ResizeObserver runtime warnings
if (process.env.NODE_ENV !== 'production') {
  // 1) 阻止 ResizeObserver loop 错误冒泡到 dev server overlay
  window.addEventListener('error', (e) => {
    if (typeof e?.message === 'string' && e.message.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation()
    }
  })

  // 2) 过滤控制台里的这条错误日志
  const originalError = console.error
  console.error = (...args: unknown[]) => {
    const msg = args[0]
    if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) {
      return
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    originalError.apply(console, args as any)
  }
}

createApp(App).use(store).use(ElementPlus).use(router).use(VueMasonryPlugin).use(i18n).mount('#app')
